// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__bc9OI","content":"Consent_content__3AOEU","footer":"Consent_footer__2xEW3"};